import { DefaultWidgetNames, WidgetType } from '@/api/rest/resources/types/widget';
import { WidgetSlotRenderer } from '@/components/widgets/WidgetSlotRenderer';
import { useWidgetSlotConfigurationByNameType } from '@/hooks/useWidgetConfigurationByOrganizationId';

import { useBGCarbonCells, useDefaultCustomCells, useOrderedCustomCells } from '../plots/hooks/useGetCustomCells';
import { ProjectTypeAccessorKey } from '../projects/pages/project/pages/sustainableProduction/components/plot-list/constants';
import { LandPageLayout } from './components/LandPageLayout';

export const LandSoilPage = () => {
  const widgetSlotsConfiguration = useWidgetSlotConfigurationByNameType(
    DefaultWidgetNames.default_template_asset_bgc,
    WidgetType.t_page,
  );

  const defaultCells = [...useDefaultCustomCells(), ...useBGCarbonCells()];
  const orderedCustomCells = useOrderedCustomCells(defaultCells, [
    ProjectTypeAccessorKey.carbonStorageBgTrend_1y,
    ProjectTypeAccessorKey.carbonStorageBg,
  ]);

  return (
    <LandPageLayout
      plotListProps={{
        customColumns: orderedCustomCells,
      }}
    >
      <WidgetSlotRenderer nestedWidget={widgetSlotsConfiguration} />
    </LandPageLayout>
  );
};
